import { z } from "zod";
import {
  PDC_AMOUNT,
  PDC_DATE,
  PDC_NO,
  PDC_REMARKS,
  YEAR
} from "./consts";

export const schema = z.object({
  [YEAR]: z.string().min(1, "This field is required"),
  [PDC_NO]: z.string().min(6, "This field must be 6 digits"),
  [PDC_AMOUNT]: z.string().min(1, "This field is required"),
  [PDC_DATE]: z.string().min(1, "This field is required"),
  [PDC_REMARKS]: z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
